// extracted by mini-css-extract-plugin
module.exports = {"root":"images-module__root___2h50v","image":"images-module__image___33iSE","more":"images-module__more___3_3rU"};